import type { FC } from "react";
import type { TrackingEvent as XpaTrackingEvent } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { LinkTarget } from "@motain/xpa-proto-files-web/lib/types/link";
import type { MatchInfoComponent } from "@motain/xpa-proto-files-web/lib/types/match_info";
import { MatchInfoEntry } from "./match-info-entry/MatchInfoEntry";
import { isNonNullable } from "@/types/isNonNullable";
import styles from "./MatchInfo.module.scss";
import classnames from "classnames";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";

export const MatchInfo: FC<MatchInfoComponent> = (props) => {
  const { title, entries } = props;

  function onClickHandler(trackingEvents: Array<XpaTrackingEvent> | undefined) {
    if (isNonNullable(trackingEvents)) {
      trackingService.sendXpaTracking(trackingEvents, EventType.EVENT_CLICK);
    }
  }

  return (
    <section className={styles.wrapper}>
      {title !== "" && (
        <header className={classnames("title-7-bold", styles.title)}>
          {title}
        </header>
      )}
      <ul className={styles.entries}>
        {entries.map((entry) => (
          <li key={entry.uiKey}>
            {isNonNullable(entry.link) ? (
              <a
                href={entry.link.urlPath}
                aria-label={entry.link.nameA11y || entry.link.name}
                className={styles.entry}
                target={`_${LinkTarget[entry.link.target]}`}
                rel={entry.link.target === LinkTarget.BLANK ? "noreferrer" : ""}
                onClick={() => {
                  onClickHandler(entry.link?.trackingEvents);
                }}
              >
                <MatchInfoEntry {...entry} />
              </a>
            ) : (
              <div className={styles.entry}>
                <MatchInfoEntry {...entry} />
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};
